import type { RegistrationExtendedFormValues } from "@buxus/shared";

type Props = {
  extendedForm: RegistrationExtendedFormValues;
  onPatch: (partial: Partial<RegistrationExtendedFormValues>) => void;
};

export function AgencyProceduresStep({ extendedForm, onPatch }: Props) {
  const toggleBool = (key: keyof Pick<
    RegistrationExtendedFormValues,
    "naturalGasEmergencies" | "hazardousLiquidContingencyPlan" | "publicEvacuation"
  >) => {
    onPatch({ [key]: !extendedForm[key] } as Partial<RegistrationExtendedFormValues>);
  };

  return (
    <>
      <h2 className="reg-step-title">Agency Procedures</h2>
      <p className="reg-step-lead">Which events have procedures?</p>
      <div className="reg-checkbox-stack">
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.naturalGasEmergencies}
            onChange={() => toggleBool("naturalGasEmergencies")}
          />
          <span>Natural gas emergencies</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.hazardousLiquidContingencyPlan}
            onChange={() => toggleBool("hazardousLiquidContingencyPlan")}
          />
          <span>Hazardous liquid contingency plan</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.publicEvacuation}
            onChange={() => toggleBool("publicEvacuation")}
          />
          <span>Public evacuation</span>
        </label>
      </div>
    </>
  );
}
